<template>
  <div class="page" style="background-color: #ffffff;width: 100%;height: 100%;">
      <van-nav-bar
        title="新增品牌信息"
        left-text="返回"
        left-arrow
        @click-left="historyBack"
      />
    <el-form ref="form" :model="addinteboStore" label-width="80px" :rules="rules" style="padding: 20px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="品牌名称" prop="parentname">
            <el-input v-model="addinteboStore.parentname"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="addinteboStore.phone" type="number"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="负责人" prop="head">
            <el-input v-model="addinteboStore.head"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button type="primary" @click="saveInteboStore" style="width: 100%">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addinteboStore:{
        storeid:"",
        parentname:"",
        parentid:"",
        phone:"",
        head:"",
      },
      rules:{
        parentname:[
          { required: true, message: "请输入品牌名称", trigger: 'blur' },
        ],
      }
    }
  },
  created() {
  },
  methods:{
    saveInteboStore(){
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$postw("inteboStore/saveInteboParentStore",this.addinteboStore).then(res=>{
            if(res.sucess){
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.$router.push({
                    path:"/addintebostore",
                    query:{
                      parentid:res.object.parentid
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/intebo/intebostore/addinteboparentstore.vue